import { render, staticRenderFns } from "./articles.vue?vue&type=template&id=1c29039d&scoped=true"
import script from "./articles.vue?vue&type=script&lang=js"
export * from "./articles.vue?vue&type=script&lang=js"
import style0 from "./articles.vue?vue&type=style&index=0&id=1c29039d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c29039d",
  null
  
)

export default component.exports